import {Routes} from '@angular/router';
import {importProvidersFrom} from '@angular/core';
import {ConnectionHttpService, SOFTLINE_SERVICE_HTTP, StoreModule} from '@softline/core';
import {SOFTLINE_FEATURE_REGISTRATION} from './registration.shared';
import * as RegistrationStore from './store/registration.store';
import {RegistrationResourceService} from './services/registration-resource.service';

export const portalRegistrationRoutes: Routes = [
  {
    path: 'registration',
    loadComponent: () => import('./pages/registration.component').then(o => o.RegistrationComponent),
    children: [
      { path: 'confirm', loadComponent: () => import('./pages/registration-confirmation/registration-confirmation.component').then(o => o.RegistrationConfirmationComponent)},
      { path: '', loadComponent: () => import('./pages/registration-form/registration-form.component').then(o => o.RegistrationFormComponent), pathMatch: 'full'},
      { path: '**', redirectTo: '/registration' },
    ],
    providers: [
      RegistrationResourceService,
      importProvidersFrom(
        StoreModule.forFeature({
          name: SOFTLINE_FEATURE_REGISTRATION,
          feature: RegistrationStore.feature,
          providers: [{
            provide: RegistrationResourceService,
            useFactory: (service: ConnectionHttpService) => new RegistrationResourceService(service),
            deps: [SOFTLINE_SERVICE_HTTP]
          }]
        }),
      )
    ]
  },
];
